import { Button, Grid, FormControl, RadioGroup, FormControlLabel, Radio, Checkbox, FormHelperText } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { AppContext } from "../../../../contexts/AppContext";
import { setStyle } from "../../../../util";
import Layout from "../../../Layout";
import TexteConsent from "./TexteConsent";
import { useNavigate } from 'react-router-dom';
import { UserService } from "../../../../services/user/userService";

const Consent = () => {
    const { defaultValues } = useContext(AppContext);
    const [consent2, setConsent2] = useState<boolean>(false);
    const [consent, setConsent] = useState<boolean>(false);
    const [hasError, setHasError] = useState<boolean>(false);
    const { server, setServer, socket, hasReadConsent, needResume, setReadConsent, jwtToken, setNeedResume } = useContext(AppContext);
    const navigate = useNavigate()

    useEffect(() => {
        if (defaultValues) { setStyle(defaultValues); }
    })

    const onSubmitForm = async (evt:any)=>{
        
        if(jwtToken && consent && consent2){
            setReadConsent(true)
            await UserService.updateUser(jwtToken, {hasReadConsent:true, needResume:needResume})
            navigate('/game');
        }else{
            setHasError(true)
        }

    }

    return (
        <Layout>
            <Grid className="container-form">
                <h2 className="serious-title" >Formulaire de consentement</h2>

                <TexteConsent />

                <form >
                    <FormControl error={hasError}>
                        <FormControlLabel sx={{alignItems: 'flex-start'}} required control={<Checkbox onChange={(e)=>{setConsent2(e.target.checked)}} />} label="J’accepte que mes données anonymisées (décision prise par la joueuse ou le joueur dans le jeu, résultats obtenus dans le jeu et informations sociodémographiques) soient déposées sur un Dataverse, sans aucune information nominative permettant de m’identifier. Les données seront ainsi disponibles pour d’autres équipes et projets de recherche." />
                        <FormControlLabel value="accepte de participer au projet" control={<Checkbox onChange={(e)=>{setConsent(e.target.checked)}} />} label="Je confirme que j’ai lu et compris les informations présentées dans ce formulaire et en cliquant sur la case, je confirme que j’accepte de participer au projet." />
                        <FormControlLabel value="résumé des résultats" control={<Checkbox onChange={(e)=>{setNeedResume(e.target.checked)}} />} label="Optionnel: Je souhaite recevoir un résumé des résultats de cette recherche à la fin du projet." />
                        {hasError && (<FormHelperText>Vous devez avoir lu et coché les cases.</FormHelperText>)}
                    </FormControl>
                    
                    <Button variant='contained' className="serious-btn" onClick={onSubmitForm} >Accepter</Button>
                </form>
            </Grid>
        </Layout>

    );
};

const Container = styled.div`
    display: flex;
    padding: 1em;
    border-radius: 5px;
`


const Main = styled.div`
    display: flex;
    flex-direction: column;
    padding: 2em;
    align-self: center;
`

const TopSubdivision = styled.div`
    display: flex;
`

const BottomSubdivision = styled.div`
    margin: auto;
    margin-top: 1em;
`


export default Consent;